export default __webpack_public_path__ + "static/media/gallery3.ede632d7.jpg";